import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InfoDialogData } from './dialog-models';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { NotificationsComponent } from '../../components/notifications/notifications.component';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../../environments/environment";
import { Notification as CsiNotification } from './notification-models';


@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog, private http: HttpClient) { }

  openInfoDialog(info: InfoDialogData): MatDialogRef<InfoDialogComponent> {
    return this.dialog.open(InfoDialogComponent, { data: info })
  }

  openNotificationsDialog(notifications: CsiNotification[]): MatDialogRef<NotificationsComponent> {
    return this.dialog.open(NotificationsComponent, { data: notifications, disableClose: true },)
  }

  getListNotifications(locale: string, profile: string): Observable<CsiNotification[]> {
    return this.http.get<CsiNotification[]>(`${environment.csibefrontend}v2/getListNotifications?locale=${locale}&profile=${profile}`);
  }

  saveOrUpdateNotificationsAccessPage(): Observable<string> {
    return this.http.post<string>(`${environment.csibefrontend}v2/saveOrUpdateNotificationsAccessPage`, null, { responseType: 'text' as 'json' });
  }
}
